var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { pageImages } from '@/pages/images';
import { StepLayout } from './step-layout.component';
import { Typography } from '@mui/material';
import { TextField } from 'hx-ui';
export function ReferenceNumber() {
    return (_jsx(StepLayout, { image: pageImages.norcReferenceNumber, progress: {
            step: 2,
            phase: 0,
        }, heading: _jsx(Typography, __assign({ variant: "h2", className: "md:text-4xl text-3xl leading-10" }, { children: "Enter your reference number" })), content: _jsx("div", __assign({ className: "flex flex-col items-center justify-center gap-16 w-full" }, { children: _jsx(TextField, { name: "reference-number", variant: "outlined", className: "md:max-w-[50%] w-full max-w-[70%]", inputProps: {
                    maxLength: 5,
                }, rules: {
                    required: 'Reference number is required',
                    pattern: {
                        value: /^\d+$/,
                        message: 'Reference number must be numeric (i.e. 00000)',
                    },
                    minLength: {
                        value: 5,
                        message: 'Reference number must be at least 5 characters',
                    },
                }, placeholder: "# Reference number" }) })) }));
}
